import React from 'react';

import {
  Typography,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Link,
  Section,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import AudienceDetails from 'scenes/CustomAudiences/Audiences/components/AudienceDetails';

const GGAudiencesSection = ({ data }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenAudience = (_e, id) => {
    openChildComponent(AudienceDetails, {
      id,
    });
  };

  const { id, name } = data.parentAudience;

  return (
    <React.Fragment>
      <Section title={'GG Audience'} isCollapsable={true} initialOpen={true}>
        <TableContainer>
          <Table width={'100%'} data-cy-role={'ggAudience'}>
            <TableBody>
              <TableRow>
                <TableCell col={'name'}>
                  <Typography>
                    <Link
                      data-cy-role={'descriptionValue'}
                      onClick={(e) => handleOpenAudience(e, id)}
                    >
                      {name}
                    </Link>
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Section>
      {childComponent}
    </React.Fragment>
  );
};

export default GGAudiencesSection;
